import { useEffect } from 'react';

interface NotificationProps {
  type: 'success' | 'error';
  message: string;
  onClose: () => void;
  duration?: number;
}

export default function Notification({ type, message, onClose, duration = 3000 }: NotificationProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className={`fixed top-4 right-4 z-50 max-w-md px-6 py-4 rounded-lg shadow-lg flex items-center gap-3 animate-slide-in ${
      type === 'success' ? 'bg-emerald-500 text-white' : 'bg-red-500 text-white'
    }`}>
      <div className="w-6 h-6 flex items-center justify-center">
        {type === 'success' ? (
          <i className="ri-checkbox-circle-fill text-xl"></i>
        ) : (
          <i className="ri-error-warning-fill text-xl"></i>
        )}
      </div>
      <p className="flex-1 font-medium">{message}</p>
      <button
        onClick={onClose}
        className="w-6 h-6 flex items-center justify-center hover:bg-white/20 rounded transition-colors"
      >
        <i className="ri-close-line text-lg"></i>
      </button>
    </div>
  );
}
